import { render, staticRenderFns } from "./xctfw.vue?vue&type=template&id=4fc604b7&scoped=true"
import script from "./xctfw.vue?vue&type=script&lang=js"
export * from "./xctfw.vue?vue&type=script&lang=js"
import style0 from "./xctfw.vue?vue&type=style&index=0&id=4fc604b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc604b7",
  null
  
)

export default component.exports